import FileCard from "./FileCard";

import PdfDownload from "./PdfDownloadOrder";
import SpinnerLoadingBlack from "../components/SpinnerLoadingBlack";

const ImportFiles = ({
  onUpload,
  handleFileUpload,
  onDownload,
  onDownloadFileCardImport,
  onDownloadFileCardBill,
  onDownload2,
  ids,
  isDownloadOneEnabled,
  isDownloadTwoEnabled,
  isDownloadThreeEnabled,
  isDownloadFourEnabled,
  isLoadingPdfUploadFirst,
  isLoadingPdfUploadSecond,
  isLoadingPdfUploadThird,
  isLoadingPdfUploadFourth,
  isUploadFirstInputDone,
  isUploadSecondInputDone,
  isUploadThirdInputDone,
  isUploadFourthInputDone,

  onDelete,
}) => {
  return (
    <div className="p-4 bg-white rounded-lg shadow-lg">
      <div className="flex gap-4 bg-gray-100 p-4 rounded-lg overflow-x-auto max-w-[1560px] custom-scrollbar">
        <div className="min-w-[360px]">
          {isLoadingPdfUploadFirst ? (
            <SpinnerLoadingBlack>Enviando PDF...</SpinnerLoadingBlack>
          ) : (
            <PdfDownload
              onUpload={(e) => onUpload(e, 1, "first")}
              onDownload={onDownload}
              isDownloadAvailable={isDownloadOneEnabled}
              isFileAvailable={ids?.googleId1}
              identifier={"isDownloadOneEnabled"}
              isUploadDone={isUploadFirstInputDone}
              onDelete={() => onDelete(ids.googleId1)}
            />
          )}
        </div>

        <div className="min-w-[360px]">
          {isLoadingPdfUploadSecond ? (
            <SpinnerLoadingBlack>Enviando PDF...</SpinnerLoadingBlack>
          ) : (
            <PdfDownload
              onUpload={(e) => onUpload(e, 2, "second")}
              onDownload={onDownload2}
              isDownloadAvailable={isDownloadTwoEnabled}
              isFileAvailable={ids?.googleId2}
              identifier={"isDownloadTwoEnabled"}
              isUploadDone={isUploadSecondInputDone}
              onDelete={() => onDelete(ids.googleId2)}
              title={"PACKING LIST - ALVO"}
            />
          )}
        </div>
        <div className="min-w-[360px]">
          {isLoadingPdfUploadThird ? (
            <SpinnerLoadingBlack>Enviando PDF...</SpinnerLoadingBlack>
          ) : (
            <PdfDownload
              onUpload={(e) => onUpload(e, 3, "BILL OF LADDER")}
              onDownload={onDownloadFileCardBill}
              isDownloadAvailable={isDownloadThreeEnabled}
              isFileAvailable={ids?.googleId3}
              identifier={"isDownloadThreeEnabled"}
              isUploadDone={isUploadThirdInputDone}
              onDelete={() => onDelete(ids.googleId3)}
              title={"BILL OF LADDER"}
            />
          )}
        </div>
        <div className="min-w-[360px]">
          {isLoadingPdfUploadFourth ? (
            <SpinnerLoadingBlack>Enviando PDF...</SpinnerLoadingBlack>
          ) : (
            <PdfDownload
              onUpload={(e) => onUpload(e, 4, "DECLARACAO DE IMPORTACAO")}
              onDownload={onDownloadFileCardImport}
              isDownloadAvailable={isDownloadFourEnabled}
              isFileAvailable={ids?.googleId4}
              identifier={"isDownloadFourEnabled"}
              isUploadDone={isUploadFourthInputDone}
              onDelete={() => onDelete(ids.googleId4)}
              title={"DECLARAÇÃO DE IMPORTAÇÃO"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ImportFiles;
